import { render } from "./StatutoryDeductionManagement.vue?vue&type=template&id=6159a104&scoped=true"
import script from "./StatutoryDeductionManagement.vue?vue&type=script&lang=js"
export * from "./StatutoryDeductionManagement.vue?vue&type=script&lang=js"

import "./StatutoryDeductionManagement.vue?vue&type=style&index=0&id=6159a104&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6159a104"]])

export default __exports__